declare const __GIT_BRANCH__: string;
declare const __GIT_COMMIT__: string;

export const apiRoute = import.meta.env.VITE_API_URL;
// harness, the AI service. The dev server rewrites this to the "/ai" proxy
// path; empty where harness has no route.
export const harnessRoute = import.meta.env.VITE_AI_URL;
// Opt in with VITE_USE_HARNESS_CHAT=true, per environment in its .env file
// (test, stage and production do; on-demand builds use test's, with their
// own ai-<slug> URL; locally, see .env.local.sample). Without a harness URL
// or the flag, the chat stays on db-api's built-in /agent endpoints.
export const useHarnessChat =
  !!harnessRoute && import.meta.env.VITE_USE_HARNESS_CHAT === "true";
export const envName = import.meta.env.MODE;
export const clvVersion = import.meta.env.VITE_APP_VERSION;
export const devTools = import.meta.env.VITE_DEV_TOOLS === "true";
export const gitBranch = __GIT_BRANCH__;
export const gitCommit = __GIT_COMMIT__;
